<template>
    <a href="javascript:;" @click="handleClick">
        <div class="gt-cell">
            <div class="top">
                <slot name="top"></slot>
            </div>
            <div class="middle">
                <div class="left">
                    <slot name="left">
                        <div class="left-img">
                            <img v-if="imgSrc"
                                 :src="imgSrc"
                                 alt="">
                        </div>
                    </slot>
                </div>
                <div class="wrapper">
                    <h4>{{title}}</h4>
                    <slot name="wrapper">
                        <p>{{des}}</p>
                    </slot>
                </div>
            </div>
            <div class="bottom">
                <slot name="bottom"></slot>
            </div>
        </div>
    </a>
</template>
<script>
import JSBridge from "../../../jsbridge";
export default {
  name: "gtCell",
  data() {
    return {};
  },
  props: {
    cell: Object,
    imgSrc: String,
    title: [String],
    des: [String]
  },
  methods: {
    handleClick($event) {
      $event.preventDefault();
      this.$emit("cellClick", this.cell);
    },
    handleToNativeClick($event) {
      $event.preventDefault();
      JSBridge.Common.Caller_Common_Base_cmd({ id: this.to }, () => {});
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../assets/css/px2rem.scss";
@import "../../../assets/css/colors.scss";
.gt-cell {
  padding: px2rem(15);
  border-top: px2rem(6) solid #f5f5f5;
  .middle {
    display: flex;
    .left {
      // background-color: $light-gray;
      &-img {
        width: px2rem(100);
        height: px2rem(68);
        img {
          width: 100%;
          height: 100%;
          border-radius: px2rem(2);
        }
      }
    }
    .wrapper {
      flex: 1;
      width: 0;
      overflow: hidden;
      max-height: px2rem(88);
      position: relative;
      h4 {
        margin: 0 px2rem(5) px2rem(4) px2rem(12);
        font-size: px2rem(14);
        line-height: px2rem(19);
        font-weight: 600;
        color: $black;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        outline: 0;
      }
      p {
        margin: px2rem(5) 0 0 px2rem(12);
        font-size: px2rem(11);
        line-height: px2rem(17);
        color: $light-gray;
      }
    }
  }
}
</style>


